/**
 * Which book template the single-face personalization page (sections/image-upload.liquid)
 * should use. DOM-free so it can be unit-tested with `node --test`; same UMD shim as
 * assets/missing-details-page.js.
 *
 * Why this exists: recomputeTemplateName() used to rebuild the template ONLY from the
 * ?template_name_boy= / ?template_name_girl= URL params. The "My Books" link
 * (sections/my-books.liquid) reopens a preview with ?preview_id= and does not carry those
 * params, so once the language map finished loading the template restored from the preview
 * was overwritten with null — and Add to Cart wrote an empty _template_name onto the order.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.TemplateNameResolver = api;
})(typeof self !== 'undefined' ? self : this, function () {
  function lower(value) {
    return typeof value === 'string' ? value.trim().toLowerCase() : value;
  }

  function resolveTemplateName(input) {
    input = input || {};
    var gender = lower(input.gender);
    if (gender !== 'boy' && gender !== 'girl') return null;

    if (input.localized) return input.localized;

    var base = gender === 'boy' ? input.boyTemplate : input.girlTemplate;
    if (base) return base;

    if (input.restoredTemplate && lower(input.restoredGender) === gender) return input.restoredTemplate;
    return null;
  }

  /**
   * The genders this book has a template for, boy first. A gender without one sent
   * "Template 'null' not found" to the generator, so the page only offers these.
   */
  function availableGenders(input) {
    input = input || {};
    var genders = [];
    if (input.localizedBoy || input.boyTemplate) genders.push('boy');
    if (input.localizedGirl || input.girlTemplate) genders.push('girl');
    return genders;
  }

  /**
   * The template to generate a book with for this gender. A single-gender book offers its one
   * template to the other gender too (crossGender: true), which the page confirms with the
   * customer before using; their chosen gender is still sent.
   */
  function templateForGender(input) {
    input = input || {};
    var gender = lower(input.gender);
    if (gender !== 'boy' && gender !== 'girl') return { template: null, crossGender: false };
    var boy = input.localizedBoy || input.boyTemplate || null;
    var girl = input.localizedGirl || input.girlTemplate || null;
    var own = gender === 'boy' ? boy : girl;
    if (own) return { template: own, crossGender: false };
    var other = gender === 'boy' ? girl : boy;
    return other ? { template: other, crossGender: true } : { template: null, crossGender: false };
  }

  return {
    resolveTemplateName: resolveTemplateName,
    availableGenders: availableGenders,
    templateForGender: templateForGender
  };
});
